import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          productFeatureId: Yup.string()
                                                               .required('Required'),
                                      });
